import { Link } from "react-router-dom";
import { handleMobileMenu } from "../utils/NavUtils";
import iconbar from "../img/iconbar.png";

import "./navbar.css";
import logo from "../img/logo.svg";

function Navbar() {
  return (
    <header className="header">
      <nav>
        <div className="container112">
          <div className="header-logo">
            <img src={logo} height="80px" alt=" " />
          </div>
          <div className="navbar">
            <div className="links">
              <a className="bb" href="/#hero">
                Home
              </a>
              <a className="bb" href="/#about">
                About
              </a>
              <a className="bb" href="/#services">
                Services
              </a>
              <a className="bb active" href="/#contact">
                {" "}
                Contact
              </a>
            </div>
          </div>
          <div className="hamburger-menu" onClick={handleMobileMenu}>
            <img className="d" src={iconbar} alt=" " />
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;
